import { render, staticRenderFns } from "./CommonArchiTree.vue?vue&type=template&id=3d53fef4&scoped=true"
import script from "./CommonArchiTree.vue?vue&type=script&lang=js"
export * from "./CommonArchiTree.vue?vue&type=script&lang=js"
import style0 from "./CommonArchiTree.vue?vue&type=style&index=0&id=3d53fef4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d53fef4",
  null
  
)

export default component.exports